import { CommonModule } from '@angular/common';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntil } from 'rxjs';
import { ShowSuccessMessageState } from '../../bloc/base-bloc';
import {
  ConfirmationBloc,
  ConfirmationCallerCallBack,
  ConfirmationReadyState,
  ConfirmationState,
  ConfirmationSubmitEvent,
} from '../../bloc/confiramtion-modal-bloc';
import { ConfirmationModalActions } from '../../common';
import { ConfirmationPopupData } from '../../interfaces';
import { BasePopUpComponent } from '../base-popup-component/base-popup.component';
import { ButtonCaller, ButtonSharedComponent } from '../shared-button-component/shared-button.component';

@Component({
  selector: 'app-modal-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, TranslateModule, ButtonSharedComponent],
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.scss'],
  providers: [ConfirmationBloc],
})
export class ModalPopupComponent<T> extends BasePopUpComponent<ConfirmationPopupData> implements OnInit {
  @Input() confirmationData: ConfirmationPopupData;
  @Input() caller: ConfirmationCallerCallBack<T>;

  // constructor
  constructor(private bloc: ConfirmationBloc, injector: Injector) {
    super([], injector);
    this.bloc.onState.pipe(takeUntil(this.destroy$)).subscribe((state) => this.onHandlePopupState(state));
  }

  ngOnInit(): void {}

  confirm(): ButtonCaller {
    return () => this.bloc.setEvent.next(new ConfirmationSubmitEvent(this.caller, ConfirmationModalActions.CONFIRM));
  }

  protected override onHandlePopupState(state: ConfirmationState): void {
    super.onHandlePopupState(state);
    if (state instanceof ShowSuccessMessageState) {
      if (state.state instanceof ConfirmationReadyState) {
        this.afterClosePopupObject = { confirmation: true };
        this.matDialogRef.close(this.afterClosePopupObject);
      }
    }
  }
}
